import { useEffect, useState } from "react";
import api from "./api";

export function useStudentPhoto(studentId, hasPhoto, version = 0) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!studentId || !hasPhoto) {
      setUrl(null);
      return undefined;
    }
    let objectUrl = null;
    let cancelled = false;
    api
      .get(`/students/${studentId}/photo`, { responseType: "blob" })
      .then(({ data }) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(data);
        setUrl(objectUrl);
      })
      .catch(() => setUrl(null));
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [studentId, hasPhoto, version]);
  return url;
}

export function useStudentData(studentId, reloadKey = 0) {
  const [data, setData] = useState({ assessments: [], goals: [], attendance: [], loaded: false });
  useEffect(() => {
    if (!studentId) return;
    Promise.all([
      api.get(`/assessments?studentId=${studentId}`),
      api.get(`/goals?studentId=${studentId}`),
      api.get(`/attendance?studentId=${studentId}`),
    ])
      .then(([a, g, att]) =>
        setData({ assessments: a.data, goals: g.data, attendance: att.data, loaded: true })
      )
      .catch(() => setData((d) => ({ ...d, loaded: true })));
  }, [studentId, reloadKey]);
  return data;
}
